import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
const BusinessProfileLayoutContent = observer(() => {
  return (
    <>
      <Outlet />
    </>
  )
})

export const BusinessProfileLayout = () => {
  return <BusinessProfileLayoutContent />
}
